const STRAPI_BASE_URL = 'https://cont.graspil.com'

const StrapiService = {
  async getLatestPostsByCategory(categorySlug, locale, limit = 5) {
    const fetchPosts = async (loc) => {
      const params = new URLSearchParams({
        'filters[categories][slug][$eq]': categorySlug,
        'sort': 'Date:desc',
        'pagination[limit]': String(limit),
        'populate': 'Image',
        'locale': loc,
      })
      const res = await fetch(`${STRAPI_BASE_URL}/api/posts?${params.toString()}`)
      if (!res.ok) return []
      const json = await res.json()
      return json?.data || []
    }

    let posts = await fetchPosts(locale)
    if (!posts.length && locale !== 'en') {
      posts = await fetchPosts('en')
    }
    return posts
  },

  getImageUrl(image) {
    const url = image?.formats?.thumbnail?.url || image?.url
    if (!url) return null
    return url.startsWith('http') ? url : `${STRAPI_BASE_URL}${url}`
  },
}

export default StrapiService
